<template>
  <div class="zone">
    <div class="zone-top">
      <div class="flex-nav">
        <div class="nav-txt" :class="active === '0' ? 'cur' : ''" @click="handleClick('0')">
          <!-- RTC专区 -->
          NTC专区
          <img src="../../assets/images/zone/img2.png" v-if="active === '0'" class="icon1" alt="">
        </div>
        <div class="nav-txt" :class="active === '1' ? 'cur' : ''" @click="handleClick('1')">
          学术活动
          <img src="../../assets/images/zone/img2.png" v-if="active === '1'" class="icon1" alt="">
        </div>
      </div>
    </div>
    <div class="zone-list" v-if="active === '0'">
      <img src="https://iep.jjmc.cn/bw/file/material/image/1899696238867361869.jpg" class="zone-ad" alt="">
      <div class="zone-item" v-for="(item, index) in subjects" :key="index">
        <div class="zone-name">{{ item && item.subjectName }}</div>
        <div class="his-list">
          <div class="his-item" v-for="(item_area, index_area) in item.areaList" :key="index_area"
            @click="handleClickItems(item_area)">
            <img :src="item_area.backdropPics && item_area.backdropPics[0].url" class="item-cover" alt="">
            <div class="item-addr">
              <div class="addr-txt">{{ item_area && item_area.hospitalName }}</div>
            </div>
            <template v-if="`${userInfo.memberType}` === '0'">
              <div v-if="`${item_area.studentSign}` === '1' && `${item_area.studentStatus}` === '2'" class="item-btn item-btned"
                @click.stop="handleCancelSign(item_area)">已报名
              </div>
              <div v-else-if="`${item_area.studentSign}` === '1'" class="item-btn cur"
                @click.stop="handleCancelSign(item_area)">已报名
              </div>
              <!-- <div v-else-if="`${item_area.peSign}` === '1'" class="item-btn cur"
                @click.stop="handleCancelSign(item_area)">管理员
              </div> -->
              <div v-else-if="`${item_area.tutorSign}` === '1'" class="item-btn cur"
                @click.stop="handleCancelSign(item_area)">导师
              </div>
              <div v-else class="item-btn">中心简介</div>
            </template>
              <div v-else-if="`${item_area.peSign}` === '1' && `${userInfo.memberType}` === '1'" class="item-btn cur"
                @click.stop="handleCancelSign(item_area)">管理员
              </div>
          </div>
          <!-- <div class="his-item">
          <img src="@/assets/logo.png" class="item-cover" alt="">
          <div class="item-addr">
            <div class="addr-txt">武汉亚心</div>
          </div>
          <div class="item-btn">中心简介</div>
        </div> -->
        </div>
      </div>
    </div>
    <trainList v-if="active === '1'"></trainList>
  </div>
</template>
<script>
import { subjectList, cancelSign } from '@/api/zone'
import trainList from '../academicActivities/trainList.vue'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  components: {
    trainList
  },
  data () {
    return {
      subjects: [],
      active: '0'
    }
  },
  // userInfo.memberType 0医生1员工
  //   不同的角色该页面展示的内容范围会有不同：
  // 1.hcp角色，会展示其报名和未报名的所有专区内容  根据userInfo.memberType判断， 0 满足， 1不满足
  // 2.其他强身员工：展示所有专区，不显示“报名”，可点击进入首页，为只读，不可评论点赞，不可留言，不可跳转学习内容，不可跳转查看直播，所有按钮只读
  // 根据userInfo.memberType判断， 1 满足， 0不满足
  // 3.PE管理员角色：会展示所有专区，但其负责管理的专区内容默认放在最上方，增加标识，其他不负责管理的专区可以进入，权限只读；
  // 4.导师角色：会展示其负责指导学习（默认放在最上方）和作为学员报名的和其他未报名的所有专区内容
  // *导师角色会在对应专区展示对应的身份，例如A专区显示导师，B专区显示已报名，则是学员
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  mounted () {
    this.handleFun()
  },
  methods: {
    handleClick(active) {
      this.active = active
    },
    handleFun () {
      subjectList({
        userId: this.userInfo.id,
        pageNum: 1,
        pageSize: 100
      }).then(res => {
        this.subjects = res.data.list
      })
    },
    handleClickItems (item) {
      if (`${item.studentStatus}` === '2') {
        this.$toast('您已被专区管理员限制访问，请联系管理员！')
        return
      }
      if (`${this.userInfo.memberType}` === '0' && `${item.studentSign}` === '0' && `${item.peSign}` !== '1' && `${item.tutorSign}` !== '1') {
        this.$router.push({
          path: `/RTCZone/sign?areaId=${item.id}`
        })
        return
      }
      this.$router.push({
        path: `/zoneDetails?areaId=${item.id}`
      })
    },
    handleCancelSign (item) {
      if (`${item.studentStatus}` === '2') {
        this.$toast('您已被专区管理员限制访问，请联系管理员！')
        return
      }
      if (`${item.tutorSign}` === '1' || `${item.peSign}` === '1') {
        this.handleClickItems(item)
        return
      }
      let params = {
        userId: this.userInfo.id,
        areaId: item.id
      }
      this.$dialog.confirm({
        // title: '',
        message: '是否需要取消报名',
      })
        .then(() => {
          // on confirm
          cancelSign(params).then(res => {
            this.handleFun()
          })
        })
        .catch(() => {
          // on cancel
        })
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.zone {
  padding: 64px 12px 16px;
  box-sizing: border-box;
  min-height: 100vh;
  background-color: #F9F8F7;

  .zone-ad {
    width: 100%;
    display: block;
    margin-bottom: 10px;
  }

  .zone-top {
    padding: 12px 16px;
    box-sizing: border-box;
    width: 100%;
    height: 64px;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    background: #F9F8F7;
  }

  .flex-nav {
    height: 42px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 55px;
    margin-bottom: 10px;
    box-sizing: border-box;
    background-image: url('../../assets/images/zone/img1.png');
    background-size: cover;
    background-repeat: no-repeat;

    .nav-txt {
      font-size: 14px;
      color: #333333;
      font-weight: 400;
      padding: 0 30px;
      box-sizing: border-box;
      position: relative;
      height: 42px;
      line-height: 42px;
      white-space: nowrap;

      .icon1 {
        width: 24px;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
        bottom: 6px;
        }

      &.cur {
        color: #EB1700;
        font-weight: 600;
      }
    }
  }

  .zone-list {
    position: relative;

    .zone-item {
      margin-bottom: 10px;
      border-radius: 12px;
      border: 2px solid #fff;
      box-sizing: border-box;
      box-shadow: 0px 6px 10px 0px rgba(255, 210, 193, 0.1), inset 0px -2px 0px 0px #FFFFFF;
      background: linear-gradient(90.00deg, rgba(235, 23, 0, 0.05),rgba(235, 23, 0, 0) 100%),rgb(255, 255, 255);

      .zone-name {
        height: 40px;
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 500;
        color: #282828;
        padding-left: 15px;
      }

      .his-list {
        background-color: #fff;
        padding: 0 17px;
        box-sizing: border-box;

        .his-item {
          display: flex;
          align-items: center;
          border-bottom: 1px solid #E1E9FA;
          padding: 10px 0;
          box-sizing: border-box;

          &:nth-last-child(1) {
            border-bottom: none;
          }

          .item-cover {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-right: 12px;
            display: block;
          }

          .item-addr {
            flex: 1;

            .addr-txt {
              font-size: 14px;
              color: #333333;
              font-weight: 500;
            }
          }

          .item-btn {
            width: 72px;
            height: 24px;
            text-align: center;
            line-height: 24px;
            color: #fff;
            font-size: 14px;
            box-sizing: border-box;
            border: 0.5px solid rgb(235, 23, 0);
            border-radius: 13px;
            background: rgb(235, 23, 0);

            &.cur {
              background: rgba(255, 227, 211, 0.4);
              color: #EB1700;
            }
            &.item-btned {
              box-sizing: border-box;
              border: 0.5px solid rgb(0, 0, 0);
              border-radius: 13px;
              color: #000000;
              background: rgb(249, 248, 247);
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/RTCZone/zoneList.vue